import { Icon, Label } from 'semantic-ui-react';

export function ArchivedBlockLabel({ archived, size }: { archived?: boolean; size?: 'mini' | 'tiny' | 'small' }) {
  if (!archived) {
    return null;
  }

  return (
    <Label basic color="red" size={size} title="This block is archived">
      <Icon name="trash" />
      Archived
    </Label>
  );
}
